module.exports = __webpack_public_path__ + "static/supports-shadow-2670a80059bc9d7025e4a594289d4caf.png";